<template>
    <ValidationObserver v-slot="{ invalid }">
        <v-card :class="{ jsCardHasError: invalid }">
            <v-card-title>
                <v-switch
                    v-model="published"
                    :label="publishedText"
                />
                <v-spacer />
                <v-radio-group
                    dense
                    v-model="level"
                    row
                >
                    <v-radio
                        label="Basic"
                        value="basic"
                        dense
                    />
                    <v-radio
                        label="Premium"
                        value="premium"
                        dense
                    />
                    <v-radio
                        label="Plus"
                        value="plus"
                        dense
                    />
                </v-radio-group>
            </v-card-title>
            <v-card-text>
                <form
                    action=""
                    method="POST"
                    @submit.prevent="save"
                >
                    <v-row>
                        <v-col
                            cols="12"
                            sm="6"
                        >
                            <ValidationProvider
                                name="section"
                                rules=""
                                v-slot="{ errors }"
                            >
                                <v-autocomplete
                                    :items="sectionsForSelect()"
                                    item-text="name"
                                    item-value="id"
                                    label="Section"
                                    v-model="section"
                                    outlined
                                    :error-messages="errors[0]"
                                >
                                    <template #item="data">
                                        <template>
                                            <v-list-item-content>
                                                <v-list-item-title v-html="data.item.name" />
                                                <v-list-item-subtitle
                                                    v-html="data.item.group"
                                                />
                                            </v-list-item-content>
                                        </template>
                                    </template>
                                </v-autocomplete>
                            </ValidationProvider>
                        </v-col>

                        <v-col
                            cols="12"
                            sm="6"
                        >
                            <ValidationProvider
                                name="section"
                                rules=""
                                v-slot="{ errors }"
                            >
                                <v-autocomplete
                                    :items="pages"
                                    item-text="name"
                                    item-value="id"
                                    label="Page"
                                    v-model="page"
                                    outlined
                                    :error-messages="errors[0]"
                                >
                                    <template #item="data">
                                        <template>
                                            <v-list-item-content>
                                                <v-list-item-title v-html="data.item.name" />
                                                <v-list-item-subtitle
                                                    v-html="data.item.group"
                                                />
                                            </v-list-item-content>
                                        </template>
                                    </template>
                                </v-autocomplete>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider
                                name="type"
                                rules="max:255"
                                v-slot="{ errors }"
                            >
                                <v-autocomplete
                                    :items="types"
                                    item-text="name"
                                    item-value="type"
                                    name="type"
                                    id="type"
                                    label="Type"
                                    v-model="type"
                                    outlined
                                    :error-messages="errors[0]"
                                />
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider
                                name="name"
                                rules="required|max:255"
                                v-slot="{ errors }"
                            >
                                <v-text-field
                                    label="Name"
                                    name="name"
                                    id="name"
                                    v-model="name"
                                    outlined
                                    :error-messages="errors[0]"
                                />
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <div class="OptionsGroup">
                        <h2 class="OptionsGroup__title">
                            Help Modal Settings
                        </h2>
                        <v-row dense>
                            <v-col cols="12">
                                <ValidationProvider
                                    name="order"
                                    rules="max:255"
                                    v-slot="{ errors }"
                                >
                                    <v-text-field
                                        label="Help Modal Title"
                                        name="helpTitle"
                                        id="helpTitle"
                                        v-model="helpTitle"
                                        outlined
                                        :error-messages="errors[0]"
                                    />
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <label class="OptionsGroup__subtitle">Help Modal Text</label>
                                <quill-editor v-model="helpText" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <ValidationProvider
                                    name="order"
                                    rules="integer"
                                    v-slot="{ errors }"
                                >
                                    <v-text-field
                                        label="Order"
                                        name="order"
                                        id="order"
                                        v-model="order"
                                        outlined
                                        :error-messages="errors[0]"
                                        type="number"
                                    />
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                    </div>
                </form>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    text
                    @click="toggledDeleteModal(true)"
                    :disabled="invalid || fields.length > 0"
                >
                    <span v-if="fields.length > 0 ">Remove attached fields to delete card</span>
                    <span v-else>Delete Card</span>
                </v-btn>
                <v-spacer />
                <v-btn
                    type="submit"
                    color="primary"
                    @click="save"
                >
                    <v-icon
                        left
                        small
                    >
                        fas fa-save
                    </v-icon>
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </ValidationObserver>
</template>

<script>
import store from '../../../../store/store';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

export default {
    computed: {
        cardId: function() {
            return this.$route.params.id;
        },

        helpText: {
            get: function() {
                return store.state.cardEditor.helpText;
            },
            set: function(value) {
                this.setHelpText(value);
            }
        },

        helpTitle: {
            get: function() {
                return store.state.cardEditor.helpTitle;
            },
            set: function(value) {
                this.setHelpTitle(value);
            }
        },

        name: {
            get: function() {
                return store.state.cardEditor.name;
            },
            set: function(value) {
                this.setName(value);
            }
        },

        order: {
            get: function() {
                return store.state.cardEditor.order;
            },
            set: function(value) {
                this.setOrder(value);
            }
        },

        published: {
            get: function() {
                return store.state.cardEditor.published;
            },

            set: function(value) {
                this.setPublished(value);
            }
        },

        section: {
            get: function() {
                return store.state.cardEditor.section;
            },
            set: function(value) {
                this.setSection(value);
            }
        },

        page: {
            get: function() {
                return store.state.cardEditor.page;
            },
            set: function(value) {
                this.setPage(value);
            }
        },

        type: {
            get: function() {
                return store.state.cardEditor.type;
            },
            set: function(value) {
                this.setType(value);
            }
        },

        level: {
            get: function() {
                return store.state.cardEditor.level;
            },
            set: function(value) {
                this.setLevel(value);
            }
        },

        ...mapState('cardEditor', ['deleteModal', 'sections', 'pages', 'types', 'fields']),

        ...mapGetters({
            publishedText: 'cardEditor/publishedText'
        })
    },

    mounted() {
        this.getData();
    },

    beforeDestroy() {
        this.helpText = '';
    },

    methods: {
        ...mapActions({
            showNotification: 'notification/show',
            getData: 'cardEditor/getData',
            saveData: 'cardEditor/saveData',
            destroyData: 'cardEditor/destroyData'
        }),

        ...mapMutations({
            toggleOverlay: 'overlay/toggle',
            setId: 'cardEditor/setCardId',
            setName: 'cardEditor/setName',
            setOrder: 'cardEditor/setOrder',
            setSection: 'cardEditor/setSection',
            setPage: 'cardEditor/setPage',
            setType: 'cardEditor/setType',
            setHelpText: 'cardEditor/setHelpText',
            setHelpTitle: 'cardEditor/setHelpTitle',
            setPublished: 'cardEditor/setPublished',
            setLevel: 'cardEditor/setLevel',
            toggledDeleteModal: 'cardEditor/toggleDeleteModal'
        }),

        save() {
            this.saveData();
        },

        sectionsForSelect() {
            let sects = [];
            this.sections.forEach(function(section) {
                sects.push({
                    id: section.id,
                    name: section.name,
                    group: section.step.name
                });
            });
            return sects;
        }
    }
};
</script>
